import { t } from '../helpers/i18n';
import { gs } from '../helpers/settings';
import GeewenLogo from './GeewenLogo';

/**
 * GeewenFooter.jsx —— 官网页脚 (首页与产品详情页共用)
 *
 * @param {object} props
 * @param {string} props.anchorBase 站内锚点前缀 (见 GeewenNav)
 */
export default class GeewenFooter {
  view(_ref) {
    let {
      anchorBase = ''
    } = _ref;
    const links = [{
      href: anchorBase + '#gs-products',
      key: 'footer.link_products'
    }, {
      href: anchorBase + '#gs-platform',
      key: 'footer.link_platform'
    }, {
      href: anchorBase + '#gs-roadmap',
      key: 'footer.link_roadmap'
    }, {
      href: anchorBase + '#gs-about',
      key: 'footer.link_about'
    }, {
      href: anchorBase + '#gs-cta',
      key: 'footer.link_contact'
    }, {
      href: '/',
      key: 'footer.link_forum'
    }].map(link => m("li", {
      key: link.key
    }, m("a", {
      href: link.href
    }, t(link.key))));
    return m("footer", {
      class: "GS-footer"
    }, m("div", {
      class: "GS-container GS-footer-inner"
    }, m("div", {
      class: "GS-footer-brand"
    }, m("span", {
      class: "GS-brand"
    }, m(GeewenLogo, null), m("span", {
      class: "GS-brand-text"
    }, m("span", {
      class: "GS-brand-name"
    }, gs('geewen_brand_name', t('meta.brand_name'))), m("span", {
      class: "GS-brand-by"
    }, gs('geewen_brand_by', t('meta.brand_by'))))), m("span", {
      class: "GS-footer-copy"
    }, gs('geewen_footer_copyright', t('footer.copyright')))), m("nav", {
      class: "GS-footer-links"
    }, m("ul", null, links)), m("span", {
      class: "GS-footer-powered"
    }, t('footer.powered'))));
  }
}
flarum.reg.add('ziiven-geewen-site', 'forum/components/GeewenFooter', GeewenFooter);